import { hstack, text, vstack } from '@onbeam/styled-system/patterns';
import { Button, Toggle } from '@onbeam/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { SubmitHandler, useForm } from 'react-hook-form';
import {
  consentFormSchema,
  consentOptions,
  convertConsentToFormValues,
  DEFAULT_FORM_VALUES,
} from './CookieConsent.utils';
import { css } from '@onbeam/styled-system/css';
import { useCookieConsentStore } from '@onbeam/utils';
import {
  ConsentFormSchemaType,
  CookieConsentProps,
} from './CookieConsent.types';

export const CookieConsentModal = ({
  consentDomain,
  i18n = {},
}: CookieConsentProps) => {
  const { consent, updateConsent } = useCookieConsentStore();

  const { register, handleSubmit } = useForm<ConsentFormSchemaType>({
    mode: 'onBlur',
    resolver: zodResolver(consentFormSchema),
    defaultValues: consent
      ? convertConsentToFormValues(consent)
      : DEFAULT_FORM_VALUES,
  });

  const onSubmit: SubmitHandler<ConsentFormSchemaType> = async ({
    ad_consent,
    ...values
  }) => {
    updateConsent(
      {
        ad_personalization: ad_consent,
        ad_storage: ad_consent,
        ad_user_data: ad_consent,
        ...values,
      },
      consentDomain,
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={vstack({ gap: '3' })}>
      {consentOptions.map(({ key, isDisabled }) => (
        <div className={vstack({ gap: '3' })} key={key}>
          <label
            htmlFor={key}
            className={hstack({
              gap: '2',
              justify: 'space-between',
            })}
          >
            <span className={text({ style: 'md' })}>
              {i18n.options?.[key].title}
            </span>
            <Toggle id={key} {...register(key)} disabled={isDisabled} />
          </label>
          <p className={text({ style: 'sm', color: 'mono.300', pr: '1' })}>
            {i18n.options?.[key].description}
          </p>
        </div>
      ))}
      <Button className={css({ mt: '3' })} type="submit" size="lg">
        {i18n.saveLabel}
      </Button>
    </form>
  );
};
